import { support } from '@src/routes'
import { makeStyles } from 'tss-react/mui'
import {
  Divider,
  Unstable_Grid2 as Grid,
  Link as MUILink,
  Typography,
} from '@mui/material'
import { Link } from '@src/components/Link'
import { useIntl } from 'react-intl'
import messages from '@src/routes/SearchResults/messages'

const useStyles = makeStyles()((theme) => ({
  sectionWrapper: {
    background: theme.palette.background.grey,
    boxShadow: 'none',
    height: '100%',
    padding: theme.spacing(5),
    [theme.breakpoints.up('lg')]: {
      background: 'white',
      boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
      maxWidth: '250px', // defined in ux design
      padding: theme.spacing(6),
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  textLink: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
  },
  headerDivider: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('xs')]: {
      marginRight: -20,
      marginLeft: -20,
    },
  },
  sectionContent: {
    marginBottom: theme.spacing(6),
  },
}))

const AdditionalHelp = (): JSX.Element => {
  const { classes } = useStyles()
  const { formatMessage } = useIntl()
  const ALDRICH_MARKET_SELECT_URL = 'https://www.aldrichmarketselect.com'

  return (
    <Grid xs={12} className={classes.sectionWrapper}>
      <Typography component="div" className={classes.heading}>
        {formatMessage(messages.NEED_ADDITIONAL_HELP)}
      </Typography>
      <Divider className={classes.headerDivider} />
      <div className={classes.sectionContent}>
        <Link href={support.customerSupport()} passHref>
          <MUILink className={classes.textLink}>
            {formatMessage(messages.CUSTOMER_SUPPORT)}
          </MUILink>
        </Link>
      </div>
      <Typography component="div" className={classes.heading}>
        {formatMessage({
          id: 'ALDRICH_MARKET_SELECT',
          defaultMessage: 'Aldrich® Market Select',
        })}
      </Typography>
      <Divider className={classes.headerDivider} />
      <div className={classes.sectionContent}>
        <MUILink
          className={classes.textLink}
          href={ALDRICH_MARKET_SELECT_URL}
          target="_blank"
        >
          {formatMessage({
            id: 'ALDRICH_MARKET_SELECT',
            defaultMessage: 'Aldrich® Market Select',
          })}
          ,{' '}
        </MUILink>
        {formatMessage(messages.ALDRICH_MARKET_SELECT_NSR)}
      </div>
    </Grid>
  )
}

export default AdditionalHelp
